import { render } from "./PrivacyPolicy.vue?vue&type=template&id=3474b522"
const script = {}

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__